const STYLES_LAZY_LOAD_DEFAULT_ELEMENT_HEIGHT = 414
const STYLES_LAZY_LOAD_DEFAULT_SMALL_ELEMENT_HEIGHT = STYLES_LAZY_LOAD_DEFAULT_ELEMENT_HEIGHT / 2

const SECTION_ITEMS_HORIZONTAL_HEIGHT = {
  SMALL: 300,
  NORMAL: STYLES_LAZY_LOAD_DEFAULT_ELEMENT_HEIGHT
}

const SIZE = {
  GIGA: '3.33em', // 60px
  MEGA: '2.66em', // 48em
  KILO: '2.22em', // 40px
  ALPHA: '2em', // 36px
  BETA: '1.5em', // 27px
  GAMMA: '1.33em', // 24px
  DELTA: '1.22em', // 22px
  // EPSILON: '1.33em',
  ZETA: '1.11em', // 19px
  BASE: '1em',
  MILLI: '0.88em', // 16px
  MICRO: '0.77em', // 0.77em
  NANO: '0.67em', // 12px
  MINI: '0.55em', // 0.55em
  TINY: '0.44em', // 8px,
  TINIER: '0.22em' // 4px
}

const SPACE = {
  TINY: SIZE.TINIER,
  SMALLEST: SIZE.TINY,
  SMALL: SIZE.NANO,
  MEDIUM: SIZE.MILLI,
  DEFAULT: SIZE.BASE,
  BIG: SIZE.ALPHA,
  BIGGER: SIZE.KILO,
  BIGGEST: SIZE.MEGA
}

const STYLES_FONT_SIZE_PX = {
  NORMAL: 18,
  SMALL: 14
}
const STYLES_FONT_SIZE = {
  BODY: SIZE.BASE,
  BODY_BIG: SIZE.ZETA,
  BODY_SMALL: SIZE.MILLI,
  BODY_SMALLER: SIZE.MICRO,
  BODY_SMALLEST: SIZE.NANO,
  HEADING_SMALL: SIZE.DELTA
}

const STYLES_PADDING = SPACE
const STYLES_MARGIN = SPACE

const STYLES_SIDEBAR_WIDTH_DESKTOP = '18em'

const STYLES_BORDER_RADIUS = {
  ROUNDED: '0.27em',
  MEDIUM: '0.5rem'
}

const STYLES_BOX_SHADOW = {
  NORMAL: '0 0.27em 2.22em rgba(0, 0, 0, 0.01), 0 0.27em 0.55em rgba(0, 0, 0, 0.05)'
}

const STYLES_WHITE_SPACE = {
  PRE: 'pre',
  PRE_WRAP: 'pre-wrap'
}

const STYLES_WORD_BREAK = {
  BREAK_WORD: 'break-word'
}

const STYLES_COLOR = {
  BLACK: '#151D21',
  BLACK_MEDIUM: '#333333',
  BLACK_LIGHT: '#666666',
  BLUE: '#4C68CB',
  GREEN: '#00B233',
  ORANGE: '#FF9600',
  GREY: '#BABABA',
  GREY_MEDIUM: '#E6E6E6',
  GREY_LIGHT: '#F6F6F6',
  RED: '#EC0000',
  WHITE: '#FFFFFF',
  WHITE_MEDIUM: '#F9F9F9'
}

const STYLES_FONT_WEIGHT = {
  BOLD: 700,
  BOLD_MEDIUM: 600,
  MEDIUM: 500,
  SEMI_BOLD: 500,
  NORMAL: 400,
  LIGHT: 300
}

const STYLES_SIZE = {
  SMALLEST: '0.44em',
  SMALLER: '1em',
  SMALL: '1.33em',
  MEDIUM: '1.77em',
  BIG: '2.22em',
  BIGGER: '3.33em',
  BIGGER_1: '4.44em',
  BIGGEST: '5.55em',
  HUGE: '11.11em'
}

const STYLES_FLEX_DIRECTION = {
  ROW: 'row',
  COLUMN: 'column'
}

const ALIGN_JUSTIFY = {
  CENTER: 'center',
  END: 'flex-end',
  START: 'flex-start'
}

const STYLES_ALIGN_ITEMS = ALIGN_JUSTIFY
const STYLES_JUSTIFY_CONTENT = ALIGN_JUSTIFY

const STYLES_CONTENT_BLOCK_WIDTH = {
  SMALL: '22em'
}

module.exports = {
  SECTION_ITEMS_HORIZONTAL_HEIGHT,
  STYLES_FLEX_DIRECTION,
  STYLES_PADDING,
  STYLES_FONT_SIZE,
  STYLES_MARGIN,
  STYLES_WORD_BREAK,
  STYLES_BORDER_RADIUS,
  STYLES_SIZE,
  STYLES_WHITE_SPACE,
  STYLES_COLOR,
  STYLES_FONT_WEIGHT,
  STYLES_JUSTIFY_CONTENT,
  STYLES_ALIGN_ITEMS,
  STYLES_BOX_SHADOW,
  STYLES_LAZY_LOAD_DEFAULT_ELEMENT_HEIGHT,
  STYLES_LAZY_LOAD_DEFAULT_SMALL_ELEMENT_HEIGHT,
  STYLES_CONTENT_BLOCK_WIDTH,
  STYLES_FONT_SIZE_PX,
  STYLES_SIDEBAR_WIDTH_DESKTOP
}
